import styled from 'styled-components';

import * as Base from './styled.default';

export const ChildrenContainer = styled(Base.ChildrenContainer)`
  > div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

export * from './styled.default';
